import { css } from 'goober';
import React from 'react';
const Holder = css `
  display: block;
  width: 22px;
  height: 20px;
`;
const MuteIcon = () => {
    return (React.createElement("span", { className: Holder },
        React.createElement("svg", { version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 448.075 448.075", xmlSpace: "preserve" },
            React.createElement("path", { fill: "#ffffff", d: "M352.021,16.075c0-6.08-3.52-11.84-8.96-14.4c-5.76-2.88-12.16-1.92-16.96,1.92l-141.76,112.96l167.68,167.68V16.075z" }),
            React.createElement("path", { fill: "#ffffff", d: "M443.349,420.747l-416-416c-6.24-6.24-16.384-6.24-22.624,0s-6.24,16.384,0,22.624l100.672,100.704h-9.376\n\tc-9.92,0-18.56,4.48-24.32,11.52c-4.8,5.44-7.68,12.8-7.68,20.48v128c0,17.6,14.4,32,32,32h74.24l155.84,124.48\n\tc2.88,2.24,6.4,3.52,9.92,3.52c2.24,0,4.8-0.64,7.04-1.6c5.44-2.56,8.96-8.32,8.96-14.4v-57.376l68.672,68.672\n\tc3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672C449.589,437.131,449.589,427.019,443.349,420.747z" }),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null))));
};
const UnMuteIcon = () => {
    return (React.createElement("span", { className: Holder },
        React.createElement("svg", { version: "1.1", id: "Capa_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 448.019 448.019", xmlSpace: "preserve" },
            React.createElement("path", { fill: "#ffffff", d: "M294.953,1.587c-5.568-2.656-12.128-1.952-16.928,1.92L122.377,128.019H48.009c-17.632,0-32,14.368-32,32v128\n\tc0,17.664,14.368,32,32,32h74.368l155.616,124.512c2.912,2.304,6.464,3.488,10.016,3.488c2.368,0,4.736-0.544,6.944-1.6\n\tc5.536-2.656,9.056-8.256,9.056-14.4v-416C304.009,9.875,300.489,4.275,294.953,1.587z" }),
            React.createElement("path", { fill: "#ffffff", d: "M385.001,110.867c-6.304-6.208-16.416-6.112-22.624,0.128c-6.208,6.304-6.144,16.416,0.128,22.656\n\tc24.192,23.872,37.504,55.968,37.504,90.368s-13.312,66.496-37.504,90.368c-6.272,6.176-6.336,16.32-0.128,22.624\n\tc3.136,3.168,7.264,4.736,11.36,4.736c4.064,0,8.128-1.536,11.264-4.64c30.336-29.856,47.008-70.048,47.008-113.088\n\tS415.337,140.787,385.001,110.867z" }),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null),
            React.createElement("g", null))));
};
export { MuteIcon, UnMuteIcon };
//# sourceMappingURL=index.js.map